import {
  ModalFooter,
  ModalFooterProps,
  useStyletron,
} from "@mezo-org/mezo-clay"

export default function StepperAbsoluteModalFooter(props: ModalFooterProps) {
  const [_, theme] = useStyletron()
  return (
    <ModalFooter
      style={{
        display: "flex",
        flexDirection: "column",
        gap: theme.sizing.scale800,
        position: "absolute",
        width: "100%",
        margin: 0,
        padding: theme.sizing.scale800,
        borderRadius: theme.borders.radius500,
        bottom: 0,
        left: 0,
        background: theme.colors.backgroundPrimary,
        boxShadow: "0 -8px 36px 0px rgba(0,0,0,0.17)",
      }}
      {...props}
    />
  )
}
